import mimeDb from "mime-db";
import { components } from "./openapi/generated-types.ts";

export type PageSpeedSettings = components["schemas"]["PageSpeedSettings"];
export type CachingConfig = components["schemas"]["CachingConfig"];
export type GzipConfig = components["schemas"]["GzipConfig"];
export type CacheCustomRule = components["schemas"]["CacheCustomRule"];
export type CachePreset = components["schemas"]["CachePreset"];

export const ALL_MIME_TYPES: readonly string[] = Object.keys(mimeDb).sort();

export const MIME_FORMAT = /^[\w.+-]+\/[\w.+-]+$/;

export const isKnownMimeType = (value: string): boolean =>
  Object.hasOwn(mimeDb, value.toLowerCase());

export const PRESET_LABELS: Record<CachePreset, string> = {
  off: "Nicht cachen",
  "1h": "1 Stunde",
  "1d": "1 Tag",
  "1w": "1 Woche",
  "1mo": "1 Monat",
  "1y": "1 Jahr",
};

export const PRESETS: readonly CachePreset[] = Object.keys(
  PRESET_LABELS,
) as CachePreset[];

export type CategoryKey = "static" | "dynamic" | "feeds";

export interface Category {
  key: CategoryKey;
  label: string;
  default: CachePreset;
  mimes: readonly string[];
  helpText: string;
}

export const CATEGORIES: readonly Category[] = [
  {
    key: "static",
    label: "Statische Assets",
    default: "1y",
    mimes: [
      "text/css",
      "application/javascript",
      "text/javascript",
      "image/jpeg",
      "image/png",
      "image/webp",
      "image/avif",
      "image/gif",
      "image/svg+xml",
      "font/woff2",
      "font/woff",
      "font/ttf",
      "font/otf",
      "video/mp4",
      "video/webm",
      "audio/ogg",
      "application/wasm",
    ],
    helpText:
      "Default-Cache-Dauer für alle MIME-Types, die nicht dynamisch oder Feed sind. In der Praxis vor allem:",
  },
  {
    key: "dynamic",
    label: "Dynamischer Content",
    default: "off",
    mimes: [
      "text/html",
      "text/markdown",
      "text/calendar",
      "application/json",
      "application/ld+json",
      "application/schema+json",
      "application/geo+json",
      "application/xml",
      "text/xml",
    ],
    helpText:
      "Inhalte, die sich häufig ändern und nicht gecacht werden sollen:",
  },
  {
    key: "feeds",
    label: "Feeds",
    default: "1h",
    mimes: [
      "application/atom+xml",
      "application/rdf+xml",
      "application/rss+xml",
    ],
    helpText: "Regelmäßig aktualisierte Feeds, die kurz gecacht werden dürfen:",
  },
];

export const GZIP_DEFAULT_MIMES: readonly string[] = [
  "application/atom+xml",
  "application/geo+json",
  "application/javascript",
  "application/json",
  "application/ld+json",
  "application/manifest+json",
  "application/rdf+xml",
  "application/rss+xml",
  "application/schema+json",
  "application/vnd.ms-fontobject",
  "application/wasm",
  "application/x-font-ttf",
  "application/x-javascript",
  "application/x-web-app-manifest+json",
  "application/xhtml+xml",
  "application/xml",
  "font/eot",
  "font/opentype",
  "font/otf",
  "font/ttf",
  "image/bmp",
  "image/svg+xml",
  "image/vnd.microsoft.icon",
  "image/x-icon",
  "text/cache-manifest",
  "text/calendar",
  "text/css",
  "text/html",
  "text/javascript",
  "text/markdown",
  "text/plain",
  "text/vcard",
  "text/vnd.rim.location.xloc",
  "text/vtt",
  "text/x-component",
  "text/x-cross-domain-policy",
  "text/xml",
];

export const DEFAULT_CACHING_CONFIG: CachingConfig = {
  enabled: false,
  static: "1y",
  dynamic: "off",
  feeds: "1h",
  custom: [],
};

export const DEFAULT_GZIP_CONFIG: GzipConfig = {
  enabled: false,
  customMimes: [],
};

export const buildDefaultCachingConfig = (): CachingConfig => ({
  ...DEFAULT_CACHING_CONFIG,
  custom: [],
});

export const buildDefaultGzipConfig = (): GzipConfig => ({
  ...DEFAULT_GZIP_CONFIG,
  customMimes: [],
});
